import React from 'react';

function MedalEmptyIcon({ width = 13, height = 27, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 13 27">
      <g>
        <polygon points="1 12.1524072 4.51066077 14.8013732 3.90833923 15.5996268 0 12.6505928 0 0 12.805 0 12.805 12.6621338 8.71983668 15.5158918 8.14716332 14.6961082 11.805 12.1408662 11.805 1 1 1"/>
        <polygon points="3.86999989 0.5 4.86999989 0.5 4.86999989 14.9995 3.86999989 14.9995"/>
        <polygon points="7.86999989 0.5 8.86999989 0.5 8.86999989 14.9995 7.86999989 14.9995"/>
        <path d="M6.371,27.0020002 C2.85185763,27.0020002 0,24.1501426 0,20.6310002 C0,17.1118579 2.85185763,14.2600002 6.371,14.2600002 C9.89014237,14.2600002 12.742,17.1118579 12.742,20.6310002 C12.742,20.8538766 12.7305947,21.0751363 12.707817,21.2932289 C12.3731658,24.5237886 9.64233953,27.0020002 6.371,27.0020002 Z M11.7132068,21.1895442 C11.7323751,21.0060758 11.742,20.8194214 11.742,20.6310002 C11.742,17.6641426 9.33785763,15.2600002 6.371,15.2600002 C3.40414237,15.2600002 1,17.6641426 1,20.6310002 C1,23.5978579 3.40414237,26.0020002 6.371,26.0020002 C9.12864577,26.0020002 11.4312524,23.9123371 11.7131595,21.189999 L12.2105,21.2415002 L11.7132068,21.1895442 Z"/>
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default MedalEmptyIcon;
